<script>
    import { onMount } from 'svelte';
	import {user} from './store/User.js';

    import Login from './app/Login.svelte';
    import Toasts from './ui/Toasts.svelte';


	export let name;

	let sidebar_id="sidebar0";
	let sidebar_closed = false;

	function toggle_sidebar() {
		sidebar_closed = !sidebar_closed;
	}

	let main_div;
	let sidebar_div;

	let navbar_width

    $: if (user.logged_in) location.href = "/";


	onMount(() => {
    	user.check_logged_in();
    });
</script>


{#if !$user.logged_in}
    <Login
        img_src="https://preview.colorlib.com/theme/bootstrap/login-form-07/images/undraw_remotely_2j6y.svg"
        allow_remember_me={false}
        allow_self_register={false}
    ></Login>
    <Toasts />

{/if}



<style>


	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}


</style>